import * as req from 'api/actions';
import * as c from './constant';

export const getFeesList = (callback) =>
  req.list(
    c.GET_FEES_LIST,
    '/api/v1/ebpls/administrator/settings/base_fees/',
    callback
  );

export const getFee = (id, callback) =>
  req.list(
    c.GET_FEE,
    `/api/v1/ebpls/administrator/settings/base_fees/${id}`,
    callback
  );

export const addFee = (payload, callback) =>
  req.create(
    c.ADD_FEE,
    `/api/v1/ebpls/administrator/settings/base_fees/`,
    payload,
    callback
  );

export const updateFee = (id, payload, callback) =>
  req.update(
    c.UPDATE_FEE,
    `/api/v1/ebpls/administrator/settings/base_fees/${id}`,
    payload,
    callback
  );

export const deleteFee = (id, params, callback) =>
  req.remove(
    c.DELETE_FEE,
    `/api/v1/ebpls/administrator/settings/base_fees/${id}`,
    params,
    callback
  );
